import { useTranslation } from "react-i18next";
import { PositionImage } from "../../../../interfaces";
import {
  formatDateAndTime,
  getFileNameWithoutFolderName,
  getFileSizeInMb,
} from "../../../../utils";

/**
 * This component is used to return card of accepted position image
 * @param param0 position image details , created At and updated by details
 */
const UpdatedAcceptedLogs = ({
  positionImage,
  createdAt,
  updatedBy,
}: {
  positionImage: PositionImage;
  createdAt?: string;
  updatedBy?: string;
}) => {
  const { t } = useTranslation();
  return (
    <div className="card-auto p-24 my-10 row row-column gap-8">
      {createdAt && (
        <div>{formatDateAndTime(createdAt, "DD.MM.YYYY HH:mm:ss")}</div>
      )}
      <div>
        {updatedBy} <strong> {t("accepted")}</strong> {t("printdata")}
      </div>
      {positionImage && (
        <div className="overflow-wrap-break-word">
          {getFileNameWithoutFolderName(positionImage.key)} (
          {positionImage.size && getFileSizeInMb(positionImage.size)}
          MB)
        </div>
      )}
    </div>
  );
};

export default UpdatedAcceptedLogs;
